/** Share of the script's voiceover missing from the video at which the confirm dialog warns. */
export const VOICEOVER_MISMATCH_WARNING_THRESHOLD = 0.7;

export function shouldWarnVoiceoverMismatch(
  mismatch: number | null | undefined,
): mismatch is number {
  return mismatch != null && mismatch >= VOICEOVER_MISMATCH_WARNING_THRESHOLD;
}

export function toMismatchPercent(mismatch: number): number {
  return Math.round(mismatch * 100);
}
